import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PRCE（P計画・Rのんびり・C安心安定・E体験） */
const prceContent: DiagnosisResultContent = {
  code: 'PRCE',
  name: 'バランス型探検家',
  catchphrase: '計画的だけど柔軟、冒険もするけど無理はしない万能型',
  rarity: 3,
  style:
    '「無理なく、でもしっかり楽しむ」を体現するバランス型。計画は立てるが余白も残し、定番の安心感を軸にしつつ新しい体験も取り入れる。のんびりしたペースで、観光・食・文化をまんべんなく味わう。極端に振れないからこそ、誰と行っても噛み合いやすい。旅の「ちょうどいい」を知る調整役タイプ。',
  strengths: [
    { lead: '調整力が高い', text: '計画と余白のバランスがよく、同行者の希望も取り込める。' },
    { lead: '安定して楽しめる', text: '定番を軸にしつつ体験も足すため、満足度が崩れにくい。' },
    { lead: '誰とでも合わせやすい', text: '極端に偏らないので、旅仲間との相性トラブルが少ない。' },
  ],
  weaknesses: [
    { lead: '個性が出にくい', text: 'バランス重視ゆえ、突き抜けた感動や尖った体験は少なめ。' },
    { lead: '決め手に欠ける', text: '選択肢を絞り切れず、優先順位付けに迷うことがある。' },
    { lead: '受け身になりがち', text: '周囲に合わせるうちに、自分の本当の希望を後回しにしやすい。' },
  ],
  aaru: [
    { icon: 'camera', text: '定番も穴場も少しずつ' },
    { icon: 'coffee', text: '予定は7割、3割は当日決め' },
    { icon: 'msg', text: '「どっちでもいいよ」が口癖' },
    { icon: 'camera', text: '観光も食もまんべんなく記録' },
  ],
  manual: {
    good: '希望を具体的に伝える／決め事は一緒に詰める',
    ng: '「全部おまかせ」で丸投げする',
    tips: '「絶対やりたい1つ」を先に決めると旅が締まる',
  },
  compatibility: {
    good: 'PACE（定番計画）／PRCZ（快適派）',
    conflict: 'SALE（爆速即興）／SRLE（冒険食）',
    tips: '譲れない1点だけ共有すれば、あとは柔軟に合わせ合える',
  },
  destinations: {
    domestic: '京都（定番と路地裏の両取り）／瀬戸内（島巡りとアート）',
    overseas: '台湾（食・観光・癒しの好バランス）／韓国（定番も新体験も）',
  },
};

export const prceDiagnosisResult = buildDiagnosisResult(prceContent);
